export type StyleTilesReply = {
    value: string;
    name: string;
    imageUrl: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Parses a style-tiles user reply.
 *
 * Accepts `unknown` input and returns a validated `StyleTilesReply` or `null` on any validation failure.
 * Lenient on unknown fields — only the three required fields are validated and extracted.
 * Returns a fresh object containing only the known fields.
 *
 * @param data - The input to parse (expected to be the user message data)
 * @returns A validated `StyleTilesReply` object, or `null` if validation fails
 */
export function parseStyleTilesReply(data: unknown): StyleTilesReply | null {
    if (!isRecord(data)) {
        return null;
    }

    const { value, name, imageUrl } = data;

    if (typeof value !== 'string' || value === '') {
        return null;
    }
    if (typeof name !== 'string' || name === '') {
        return null;
    }
    if (typeof imageUrl !== 'string' || imageUrl === '') {
        return null;
    }

    // Return a fresh object containing only the known fields
    // (unknown fields from input are not spread through)
    return { value, name, imageUrl };
}
